import { NgModule } from '@angular/core';

import { MyDisableIfHasNotPermissionDirective } from "@bt/directives/disable.directive";
import { MyHideIfHasNotPermissionDirective } from "@bt/directives/hide.directive";

@NgModule({
  imports: [
  ],
  exports:[    
    MyDisableIfHasNotPermissionDirective,
    MyHideIfHasNotPermissionDirective],
  declarations: [
    MyDisableIfHasNotPermissionDirective,
    MyHideIfHasNotPermissionDirective
  ],
})
export class DirectiveModule { }


// WEBPACK FOOTER //
// ./src/app/directives/directive.module.ts